import React from 'react';

export default function Spinner({ label = 'Laden...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3" data-testid="loading-spinner">
      <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      <div className="overline text-muted-foreground">{label}</div>
    </div>
  );
}
